import { BaseField, BaseFieldModel } from '../baseField';
import { FieldType } from '../fieldType';
import { CultureTextModel } from '../form';

export type AllowedVideoPlayers = 'youtube';

export interface VideoFieldModel extends BaseFieldModel {
  defaultValue: CultureTextModel[] | string;
  videoPlayer: AllowedVideoPlayers;
  type: FieldType.Video;
}

export class VideoField extends BaseField implements VideoFieldModel {
  public defaultValue: CultureTextModel[] | string = '';
  public videoPlayer: AllowedVideoPlayers = 'youtube';
  public type: FieldType.Video = FieldType.Video;

  constructor(cultures: string[]) {
    super(FieldType.Video, cultures);

    this.defaultValue = [];

    for (const culture of cultures) {
      this.defaultValue.push({ culture, value: '' });
    }
  }
}
